import { Box, Dialog, Typography } from "@mui/material";
import { ApplicationContext } from "../context/application_ctx";
import { font } from "../styles/font";
import { theme } from "../styles/theme";
import { ButtonCustom } from "./button";
import { useContext } from "react";
import dayjs from "dayjs";

export const PlanExpiryDialog = ({ profileDetails, licenceBatchList }) => {
  const { expiryDialog, setExpiryDialog, setActiveTab } =
    useContext(ApplicationContext);
  const handleClose = () => {
    setExpiryDialog(false);
  };

  const handleDetails = () => {
    setActiveTab(2);
    handleClose();
  };

  let expiryDates = licenceBatchList
    ?.slice(1)
    .map((dates, i) => dayjs().isAfter(dates.expirationDate))
    ?.every((everyDate) => everyDate === true);
  console.log(expiryDates, "expdate");

  // let expiredPlan = dayjs().isAfter(expiryDates[0]) && dayjs().isAfter(expiryDates[0]) && dayjs().isAfter(expiryDates[0])
  return (
    <>
      <Dialog
        open={expiryDialog}
        fullWidth
        maxWidth={"100%"}
        maxheight={"100%"}
        PaperProps={{
          style: {
            maxHeight: "100%",
            width: "462px",
          },
        }}
        //   onClose={handleClose}
      >
        <Box
          display="flex"
          flexDirection="column"
          // alignItems="center"
          gap="33px"
          width="100%"
          padding={"19px 19px"}
          backgroundColor={theme.col_4}
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="flex-end"
            width="94%"
            position="absolute"
          >
            {/* <IconButton 
              // onClick={handleClose}
              >
                <CancelIcon sx={{ fontSize: "32px", color: theme.col_2 }} />
              </IconButton> */}
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            width="100%"
          >
            <Typography
              fontFamily={font.family.fm_2}
              color={theme.col_3}
              // textAlign="center"
              textTransform="capitalize"
              fontSize={font.size.fs_2}
              fontWeight="bold"
            >
              Hey, {profileDetails.name}
            </Typography>
            <Typography
              fontFamily={font.family.fm_2}
              color={theme.col_2}
              // textAlign="center"
              fontSize={font.size.fs_5}
              fontWeight="bold"
            >
              Your{" "}
              {licenceBatchList?.length === 1 && !licenceBatchList[0]?.isDemo
                ? "Trial"
                : expiryDates
                ? "Standard"
                : ""}{" "}
              Plan is expired ,
            </Typography>
            <Typography
              fontFamily={font.family.fm_2}
              color={theme.col_2}
              // textAlign="center"
              fontSize={font.size.fs_5}
              fontWeight="bold"
            >
              Subscribe to our Plan to continue
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
          >
            <ButtonCustom
              onClick={handleDetails}
              fullWidth={false}
              width="90px"
              // disabled={loaderState}
              // loaderState={loaderState}
              // borderRadius="42px"
              // size="large"
              background={theme.col_2}
              backgroundRipple={theme.col_3}
              focusColor={theme.col_1}
              display="flex"
              alignItems="center"
              justifyContent="center"
              typography={
                <Typography
                  fontFamily={font.family.fm_2}
                  textTransform={"capitalize"}
                  fontSize={font.size.fs_3}
                  // fontWeight="bold"
                  color={theme.col_4}
                >
                  {"Subscribe"}
                </Typography>
              }
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
